import {createFileRoute} from '@tanstack/react-router';
import {ClosePage} from 'pages/error/ClosePage';

export const Route = createFileRoute('/close')({
  component: ClosePage,
});
